(() => {
  const comparisonTables = document.querySelectorAll('[data-comparison-table]');
  const KEYCODE_SPACE = 32;

  if (comparisonTables.length > 0) {
    comparisonTables.forEach(table => {
      let selected = [0, 1];
      const expandButton = table.querySelector('[data-expand-all]'),
             sectionHead = table.querySelector('[data-section-head]'),
                sections = table.querySelectorAll('.checkbox_section'),
         sectionsFilters = table.querySelectorAll('.table_filter'),
                   arias = table.querySelectorAll('[aria-expanded]'),
                    tab = table.closest('.tab_panel'),
            isTabOpened = () => !!tab.classList.contains('checked'),
              toggleText = text => expandButton.innerHTML = text,
                isTablet = () => window.innerWidth < 900,
               isDesktop = () => window.innerWidth >= 1200,
             getSelected = () => selected,
             setSelected = newValue => selected = newValue;

      const toggleProduct = current => {
        const index = parseInt(current.dataset.value, 10);
        const prod = [...getSelected()];
        const indexOf = prod.indexOf(index);
        let count = getSelected().length;

        if (current.classList.contains('checked')) {
          if ((isTablet() && count >= 2) || (!isTablet() && count >= 4)) {
            prod.splice(0, 1);
          }
          prod.push(index);
        } else if (count <= 2) {
          current.classList.add('checked');
        } else {
          prod.splice(indexOf, 1);
        }

        sectionsFilters.forEach(filter => {
          let productId = parseInt(filter.dataset.value, 10);
          let products = table.querySelectorAll('[data-product-id=\'' + productId + '\']');
          let checked = (prod.indexOf(productId) !== -1);

          filter.classList.toggle('checked', checked);
          products.forEach(product => product.classList.toggle('show-product', checked));
        });

        setSelected(prod);
      };

      const setFilters = (selected) => {
        setSelected([...selected].slice(0, (isTablet() ? 2 : 4)));

        sectionsFilters.forEach(filter => {
          let productId = parseInt(filter.dataset.value, 10);
          let products = table.querySelectorAll('[data-product-id=\'' + productId + '\']');
          let checked = (productId <= getSelected().length - 1);
          filter.classList.toggle('checked', checked);
          products.forEach(product => product.classList.toggle('show-product', checked));
        });
      }

      if (sectionsFilters.length > 0) {
        const showedProducts = Array.from(Array(sectionsFilters.length).keys());

        sectionsFilters.forEach(filter => filter.addEventListener('click', () => setTimeout(() => toggleProduct(filter), 100)));

        if (sections.length > 0 && expandButton) {
          let collapse = false;
          !!expandButton.dataset.textExpand && toggleText(expandButton.dataset.textExpand);

          expandButton.addEventListener('click', event => {
            collapse = !collapse;
            sections.forEach(section => section.classList.toggle('checked', collapse));
            arias.forEach(aria => aria.setAttribute('aria-expanded', `${collapse}`));

            if (!!expandButton.dataset.textExpand && !!expandButton.dataset.textCollapse) {
              if (collapse) {
                toggleText(event.target.dataset.textCollapse);
              } else {
                toggleText(event.target.dataset.textExpand);
              }
            }
          });

          expandButton.addEventListener('keydown', e => {
            if (e.key === ' ' || e.keyCode === KEYCODE_SPACE) {
              e.preventDefault();
              expandButton.click();
            }
          });
        }

        setFilters(showedProducts);

        let resetTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resetTimeout);
          resetTimeout = setTimeout(() => setFilters(showedProducts), 50);
        });
      }

      if (sectionHead.classList.contains('static')) return;

      const nav = document.querySelector('[data-secondary-nav]'),
        content = table.querySelector('[data-table-content]'),
      secondary = () => nav?.classList.contains("sticky") && isDesktop() ? nav.offsetHeight : 0,
     stickyHead = () => {
        if (!!tab && !isTabOpened()) return;

        let tableRect = content.getBoundingClientRect();
        let headerRect = sectionHead.getBoundingClientRect();
        let isCustomSticky = sectionHead.classList.contains('custom-sticky');
        let start = tableRect.top + secondary() <= 0;
        let end = tableRect.bottom > headerRect.height + secondary();

        sectionHead.classList.toggle("sticky", start);
        isCustomSticky && (start && end) && sectionHead.style.setProperty('--scroll-top', `${Math.abs(tableRect.top)}px`);
      };

      stickyHead();
      document.addEventListener('DOMContentLoaded', () => {
        window.addEventListener('scroll', stickyHead, {passive: true});
        window.addEventListener('resize', stickyHead, {passive: true});
      });
    });
  }
})();
